import type { StyleConfiguration } from '@keyvue/one-ui';

const styleConfig: StyleConfiguration = {
    'global': {
        'sizes': {
            size: {
                xs: '5px',
                sm: '10px',
                md: '20px',
                lg: '30px',
                xl: '40px',
            },
        },
        'font-weight': {
            light: 300,
            normal: 400,
            medium: 600,
            bold: 700,
        },
    },
    'alert': {
        'border-radius': '10px',
    },
    'button': {
        block: {
            'border-radius': 'var(--global-sizes-size--lg)',
        },
        outline: {
            'padding': '0 var(--global-sizes-size--xl)',
            'border-radius': 'var(--global-sizes-size--lg)',
        },
    },
    'list': {
        container: {
            'border-radius': '15px',
            'header': {
                'background-color': '#D8D8D8',
            },
        },
        row: {
            'hover-color': '#edeef8',
        },
    },
    'card': {
        'border-radius': '10px',
        'box-shadow': '0',
        'border-width': '1px',
    },
    'tabs': {
        inline: {
            'separator-height': '1px',
            'separator-color': '#ddd',
        },
    },
    'text': {
        description: {
            'color': 'gray-800',
            'line-height': '1.6em',
        },
    },
    'input-group': {
        label: {
            'font-size': '13px',
            'color': '#2E364D',
        },
        input: {
            'shared': {
                'border-radius': '10px',
                'checked-color': '#0083b8',
            },
            'file-drop-zone': {
                'background-color': '#edeff6',
            },
        },
    },
    'overlay': {
        'modal-dialog': {
            'border-radius': '10px',
            'close-color': '#989EA9',
            'close-position': '10px',
        },
    },
};

export default styleConfig;
